import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useI18n } from '@hydra/common/customHooks';
import { Icon, MenuItem, Translate } from '@hydra/common/components';

import { IconButton, OutlinedInput, Typography, Button, Popover, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(1)
  },
  row: {
    display: 'flex'
  },
  popover: {
    padding: theme.spacing(1)
  },
  textPreview: {
    fontSize: theme.typography.fontSizeSmall,
    maxWidth: '240px'
  },
  fixedWidth: {
    width: 190
  }
}));

const FilterString = ({
  onChange: handleChange,
  value = { operator: 'AND', values: [{ string: '', operator: 'CONTAINS' }] },
  label
}) => {
  const classes = useStyles();
  const { translate } = useI18n();
  const [open, setOpen] = useState(false);
  const anchorElement = useRef();

  const handleTogglePopup = () => {
    setOpen(o => !o);
  };

  const handleClearValues = (event) => {
    event.stopPropagation();
    handleChange.reset(event);
  };

  const values = value.values;

  return (
    <div className={classes.root}>
      <Button
        onClick={handleTogglePopup}
        variant='outlined'
        size='small'
        ref={anchorElement}
      >
        {label}
        {
          values.filter(v => v.string !== '').length > 0
            ? (
              <>
                <Typography noWrap className={classes.textPreview}>
                  :
                  {
                    values
                      .filter(v => v.string !== '')
                      .map(
                        v => v.operator === 'NOT_CONTAINS'
                          ? ' ' + translate('crawler_filter_preview_not') + ` "${v.string}" `
                          : ` "${v.string}" `
                      )
                      .join(` ${value.operator} `)
                  }
                </Typography>
                <IconButton onClick={handleClearValues} name='RESET' size='small' component='span'>
                  <Icon type='cross' size='xs' />
                </IconButton>
              </>
              )
            : null
        }
      </Button>

      <Popover
        PaperProps={{
          classes: {
            root: classes.popover
          }
        }}
        open={open}
        onClose={handleTogglePopup}
        anchorEl={anchorElement.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        BackdropProps={{
          invisible: false
        }}
      >
        <Select
          variant='outlined'
          style={{ display: values.length > 1 ? '' : 'none', marginRight: 'auto' }}
          value={value.operator}
          onChange={handleChange.changeBooleanOperator}
        >
          <MenuItem value='AND'>
            <Translate content='crawler_and' />
          </MenuItem>
          <MenuItem value='OR'>
            <Translate content='crawler_or' />
          </MenuItem>
        </Select>
        <div>
          {
            values.map((value, index) => {
              return (
                <div key={index} className={classes.row}>
                  <Select
                    className={classes.fixedWidth}
                    variant='outlined'
                    value={value.operator}
                    onChange={handleChange.changeContainsOperator(index)}
                  >
                    <MenuItem value='CONTAINS'>
                      <Typography noWrap variant='body2'>
                        <Translate content='crawler_contains' />
                      </Typography>
                    </MenuItem>
                    <MenuItem value='NOT_CONTAINS'>
                      <Typography noWrap variant='body2'>
                        <Translate content='crawler_not_contains' />
                      </Typography>
                    </MenuItem>
                  </Select>
                  &nbsp;
                  <OutlinedInput
                    autoFocus={index === 0}
                    size='small'
                    onChange={handleChange.changeString(index)}
                    value={value.string}
                    className={classes.fixedWidth}
                    endAdornment={
                      values.length > 1
                        ? (
                          <IconButton
                            edge='start'
                            size='small'
                            onClick={handleChange.deleteInput(index)}
                          >
                            <Icon type='cross' size='sm' />
                          </IconButton>
                          )
                        : null
                    }
                  />
                  &nbsp;
                  {
                    ((index + 1) === values.length)
                      ? (
                        <IconButton
                          disabled={index > 4}
                          size='small'
                          onClick={handleChange.addInput}
                        >
                          <Icon type='plus' />
                        </IconButton>
                        )
                      : null

                  }
                </div>
              );
            })
          }
        </div>
      </Popover>
    </div>
  );
};

FilterString.propTypes = {
  onChange: PropTypes.object,
  value: PropTypes.object,
  label: PropTypes.node
};

export default FilterString;
